var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPqrs(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 110.55 110.55",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #ffcf04;\n      }\n\n      .cls-1, .cls-2 {\n        stroke-width: 0px;\n      }\n\n      .cls-2 {\n        fill: #003893;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_1352",
    "data-name": "Grupo 1352"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_1408",
    "data-name": "Trazado 1408",
    className: "cls-1",
    d: "M87.35,21.06h-6.53c-1.1-9.73-9.33-17.09-19.12-17.1H23.2c-10.62.01-19.23,8.62-19.24,19.24v59.24c0,3.89,3.15,7.05,7.04,7.05,1.39,0,2.75-.41,3.91-1.18l15.07-10.05c1.8,9,9.7,15.48,18.88,15.49h29.29l17.48,11.66c3.24,2.16,7.61,1.28,9.77-1.95.77-1.16,1.18-2.52,1.18-3.91v-59.24c-.01-10.62-8.62-19.23-19.24-19.25M12.54,84.75c-1.27.85-2.99.5-3.84-.77-.3-.45-.46-.99-.46-1.53V23.2c0-8.26,6.71-14.96,14.97-14.97h38.49c8.26,0,14.96,6.7,14.97,14.97v34.21c0,8.26-6.71,14.96-14.97,14.97h-29.66c-.51,0-1.02.13-1.47.37l-18.01,12h0ZM102.31,99.55c0,1.53-1.25,2.77-2.78,2.76-.54,0-1.08-.16-1.53-.46l-18.02-12.01c-.35-.23-.76-.36-1.18-.36h-29.93c-7.44,0-13.74-5.47-14.81-12.83h27.64c10.62-.01,19.23-8.62,19.25-19.24V25.34h6.41c8.26,0,14.96,6.7,14.97,14.97v59.24h-.01Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_1409",
    "data-name": "Trazado 1409",
    className: "cls-2",
    d: "M61.08,22.9c0-.98.8-1.78,1.78-1.78h3.55c.98,0,1.78.8,1.77,1.78,0,.98-.79,1.77-1.77,1.77h-3.55c-.98,0-1.78-.8-1.78-1.78"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_1410",
    "data-name": "Trazado 1410",
    className: "cls-2",
    d: "M42.45,24.68h16.19c.98,0,1.78-.8,1.77-1.78,0-.98-.79-1.77-1.77-1.77h-16.19c-.98,0-1.78.8-1.78,1.78s.8,1.78,1.78,1.78"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_1411",
    "data-name": "Trazado 1411",
    className: "cls-2",
    d: "M34.45,24.68h3.55c.98,0,1.78-.8,1.77-1.78,0-.98-.79-1.77-1.77-1.77h-3.55c-.98,0-1.78.8-1.78,1.78s.8,1.78,1.78,1.78"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_1412",
    "data-name": "Trazado 1412",
    className: "cls-2",
    d: "M20.24,24.68h9.92c.98,0,1.78-.8,1.77-1.78,0-.98-.79-1.77-1.77-1.77h-9.92c-.98,0-1.78.8-1.78,1.78s.8,1.78,1.78,1.78"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_1413",
    "data-name": "Trazado 1413",
    className: "cls-2",
    d: "M61.08,44.21c0-.98.8-1.78,1.78-1.78h3.55c.98,0,1.78.8,1.78,1.78s-.8,1.78-1.78,1.78h-3.55c-.98,0-1.78-.8-1.78-1.78"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_1414",
    "data-name": "Trazado 1414",
    className: "cls-2",
    d: "M42.45,45.99h16.19c.98,0,1.78-.8,1.78-1.78s-.8-1.78-1.78-1.78h-16.19c-.98,0-1.78.8-1.78,1.78s.8,1.78,1.78,1.78"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_1415",
    "data-name": "Trazado 1415",
    className: "cls-2",
    d: "M34.45,45.99h3.55c.98,0,1.78-.8,1.78-1.78s-.8-1.78-1.78-1.78h-3.55c-.98,0-1.78.8-1.78,1.78s.8,1.78,1.78,1.78"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_1416",
    "data-name": "Trazado 1416",
    className: "cls-2",
    d: "M20.24,45.99h9.92c.98,0,1.78-.8,1.78-1.78s-.8-1.78-1.78-1.78h-9.92c-.98,0-1.78.8-1.78,1.78s.8,1.78,1.78,1.78"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_1417",
    "data-name": "Trazado 1417",
    className: "cls-2",
    d: "M61.08,54.87c0-.98.8-1.78,1.78-1.78h3.55c.98,0,1.78.8,1.78,1.78s-.8,1.78-1.78,1.78h-3.55c-.98,0-1.78-.8-1.78-1.78"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_1418",
    "data-name": "Trazado 1418",
    className: "cls-2",
    d: "M42.45,56.65h16.19c.98,0,1.78-.8,1.78-1.78s-.8-1.78-1.78-1.78h-16.19c-.98,0-1.78.8-1.78,1.78s.8,1.78,1.78,1.78"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_1419",
    "data-name": "Trazado 1419",
    className: "cls-2",
    d: "M34.45,56.65h3.55c.98,0,1.78-.8,1.78-1.78s-.8-1.78-1.78-1.78h-3.55c-.98,0-1.78.8-1.78,1.78s.8,1.78,1.78,1.78"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_1420",
    "data-name": "Trazado 1420",
    className: "cls-2",
    d: "M20.24,56.65h9.92c.98,0,1.78-.8,1.78-1.78s-.8-1.78-1.78-1.78h-9.92c-.98,0-1.78.8-1.78,1.78s.8,1.78,1.78,1.78"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_1421",
    "data-name": "Trazado 1421",
    className: "cls-2",
    d: "M20.24,35.34h3.55c.98,0,1.78-.8,1.78-1.78s-.8-1.78-1.78-1.78h-3.55c-.98,0-1.78.8-1.78,1.78s.8,1.78,1.78,1.78"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_1422",
    "data-name": "Trazado 1422",
    className: "cls-2",
    d: "M66.41,31.78h-9.36c-.98,0-1.78.8-1.78,1.78s.8,1.78,1.78,1.78h9.36c.98,0,1.78-.8,1.78-1.78s-.8-1.78-1.78-1.78h0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_1423",
    "data-name": "Trazado 1423",
    className: "cls-2",
    d: "M28.8,35.34h23.4c.98,0,1.78-.8,1.78-1.78s-.8-1.78-1.78-1.78h-23.4c-.98,0-1.78.8-1.78,1.78s.8,1.78,1.78,1.78"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPqrs);
export default __webpack_public_path__ + "static/media/pqrs.3a9e2a3b6da2cae90988e080688ceae4.svg";
export { ForwardRef as ReactComponent };